import { works } from "@/api/work/useWorkQuery";
import { workLogs } from "@/api/workLogs/useWorkLogsQuery";
import useFetcher from "@/hooks/useFetcher";
import { usePaginationStore } from "@/store/pagenation.store";
import { WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useProductionPerformanceFetch = () => {
  const { currentPage } = usePaginationStore((state) => ({
    currentPage: state.currentPage,
  }));

  // PERFORMANCE workLog의 workId 목록 조회
  const { queryKey: perfKey, queryFn: perfFn } = workLogs.find({
    query: {
      $and: [
        {
          workLogType: {
            $eq: WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.PERFORMANCE,
          },
        },
      ],
    },
    fields: ["workId"],
  });

  const { data: performanceLogsData } = useQuery({
    queryKey: perfKey,
    queryFn: perfFn,
  });

  const performanceWorkIds = useMemo(() => {
    const logs = (performanceLogsData?.data ?? []) as Array<{
      workId?: number;
    }>;
    const ids = logs
      .map((log) => log.workId)
      .filter((id): id is number => id != null);
    return [...new Set(ids)];
  }, [performanceLogsData]);

  const hasIds = performanceWorkIds.length > 0;

  const { queryKey, queryFn } = works.itemWork({
    page: currentPage ?? 1,
    query: {
      $and: [{ id: { $in: hasIds ? performanceWorkIds : [-1] } }],
    },
    dates: [new Date("2000-01-01"), new Date("2099-12-31")],
    sort: "-createdAt",
    populate: ["equipment", "summary", "item", "productionPlan", "routingData"],
    pageSize: 10,
  });

  const { data, Fetcher } = useFetcher(
    { queryKey, queryFn },
    { enabled: performanceLogsData !== undefined }
  );

  return { data, Fetcher };
};
